module.exports = __webpack_public_path__ + "img/gather ruffle.48969f0c.png";